import React from "react";
import PageHeader from "components/PageHeader";
import { useProfileLogic } from "./hooks/useProfileLogic";
import {
  ProfileHeader,
  ProfileFormField,
  ProfileInfoCard,
  ProfileActions,
  SettingsCard,
  LoadingState,
  VilleSelect,
} from "./components";

/**
 * Page de profil utilisateur
 * Permet de consulter et modifier les informations du parent
 */
function ProfilePage() {
  const {
    // État
    parentData,
    isLoadingParent,
    isUpdating,
    isEditing,
    errors,
    
    // Fonctions de formulaire
    register,
    handleSubmit,
    onSubmit,
    
    // Actions
    handleEdit,
    handleCancel,
    handleNavigate,
    handleBack,
  } = useProfileLogic();

  if (isLoadingParent) {
    return <LoadingState />;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <PageHeader title="Mon Profil" onBack={handleBack} />

      <div className="p-4 max-w-2xl mx-auto">
        {/* Carte de profil */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-4">
          {/* Avatar et nom */}
          <ProfileHeader 
            fullName={parentData?.fullName}
            phone={parentData?.phone}
          />

          {/* Informations du compte */}
          <div className="border-t pt-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-700">
                Informations du compte
              </h3>
              {!isEditing && (
                <ProfileActions
                  isEditing={isEditing}
                  isUpdating={isUpdating}
                  onEdit={handleEdit}
                  onCancel={handleCancel}
                />
              )}
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
              {/* Nom complet */}
              <ProfileFormField
                label="Nom complet"
                value={parentData?.fullName}
                isEditing={isEditing}
                register={register("fullName", {
                  required: "Le nom est requis",
                })}
                error={errors.fullName}
                placeholder="Votre nom complet"
              />

              {/* Téléphone */}
              <ProfileFormField
                label="Numéro de téléphone"
                value={parentData?.phone}
                isEditing={false}
                isReadOnly={true}
                helperText="Le numéro de téléphone ne peut pas être modifié"
              />

              {/* Adresse */}
              <ProfileFormField
                label="Adresse"
                value={parentData?.adresse}
                isEditing={isEditing}
                register={register("adresse")}
                error={errors.adresse}
                placeholder="Votre adresse"
              />

              {/* Ville */}
              <VilleSelect
                value={parentData?.ville?.name}
                isEditing={isEditing}
                register={register("villeId")}
                error={errors.villeId}
              />

              {/* Type de compte */}
              <ProfileInfoCard
                label="Type de compte"
                value={parentData?.type}
                type="badge"
              />

              {/* Crédits */}
              <ProfileInfoCard
                label="Crédits disponibles"
                value={parentData?.credits}
                type="credits"
              />

              {/* Dernière utilisation de crédits */}
              <ProfileInfoCard
                label="Dernière utilisation de crédits"
                value={parentData?.last_credit_usage}
                type="date"
              />

              {/* Nombre d'enfants */}
              <ProfileInfoCard
                label="Nombre d'enfants"
                value={parentData?.countEnfant}
                type="count"
              />

              {/* Boutons d'action */}
              {isEditing && (
                <ProfileActions
                  isEditing={isEditing}
                  isUpdating={isUpdating}
                  onEdit={handleEdit}
                  onCancel={handleCancel}
                />
              )}
            </form>
          </div>
        </div>

        {/* Paramètres du compte */}
        <SettingsCard onNavigate={handleNavigate} />
      </div>
    </div>
  );
}

export default ProfilePage;
